"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class ReferenceAnnotationMarkedImages {
    constructor(imageName, pixelX, pixelY) {
        this.imageName = imageName;
        this.pixelX = pixelX;
        this.pixelY = pixelY;
    }
}
exports.ReferenceAnnotationMarkedImages = ReferenceAnnotationMarkedImages;
